import messages from './perfil-featured-translations';
import { ApplicationConstants } from '../../../shared/applicationConstants';

export default {
    name: 'instamapsPerfilFeatured',
    i18n: {
        messages,
    },
    computed: {
        galeria: function(){
            let galeria = window.location.origin + ApplicationConstants.userGalleryUrl + this.user.uid;
            if(this.user.tipusEntitatId === 2){
                galeria = galeria + "&tipusApp=2";
            }
            if(this.user.tipusEntitatId === 12){
                galeria = galeria + "&tipusApp=4";
            }
            return galeria;
        }
    },
    props: {
        user: { type: Object },
    }
};



// WEBPACK FOOTER //
// ./src/perfil/components/perfil-featured/perfil-featured.js